import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import Autocomplete from 'react-autocomplete';
import { connect } from 'react-redux';
import { fetchStock } from '../reducers/stock';

class Search extends Component {
  constructor(props) {
    super(props);

    this.state = {
      value: '',
      symbols: [],
      loading: false
    };
  }

  render() {
    return (
      <Autocomplete
        inputProps={{
          id: 'symbol-autocomplete',
          className: 'w-100 b--none br2 pa2 ph3 items-center border-box bg-black-30 white',
          placeholder: 'Search ticker or company'
        }}
        wrapperStyle={{}}
        wrapperProps={{ className: 'w-100 border-box' }}
        value={this.state.value}
        items={this.state.symbols}
        getItemValue={(item) => item.name}
        onSelect={(value, item) => {
          this.setState({ value, symbols: [item] });

          if (this.props.currentSymbol) {
            this.props.fetchStock(item.symbol);
          }

          this.props.history.push('/quote/' + item.symbol);
        }}
        onChange={(event, value) => {
          this.setState({ value });
          if (value === '') {
            this.setState({ symbols: [] });
          } else {
            fetch(`${process.env.REACT_APP_API_URI}/api/v1/search/${value}`)
              .then((response) => response.json())
              .then((response) => {
                this.setState({ symbols: response });
                // console.log(this.state.symbols);
              })
              .catch((err) => {
                console.log(err);
              });
          }
        }}
        renderItem={(item, isHighlighted) => (
          <div className={isHighlighted ? 'bg-near-white pa2' : 'pa2'} key={item.symbol}>
            <span className="fw6">{item.name}</span>
            <br />
            <span>{item.symbol}</span>
          </div>
        )}
        renderMenu={(children, value) => (
          <div
            className={
              value === '' || children.length === 0
                ? 'dn'
                : 'bg-white overflow-auto br2 mt2 fixed shadow-custom w5 z-4'
            }
          >
            {children}
          </div>
        )}
      />
    );
  }
}

export default connect((state) => ({ currentSymbol: state.stock.currentSymbol }), { fetchStock })(
  withRouter(Search)
);



// WEBPACK FOOTER //
// ./src/components/Search.js